{
  "EMOTION_LABELS": {
    "happy": "喜悦",
    "angry": "愤怒",
    "sad": "悲伤",
    "afraid": "恐惧",
    "disgusted": "厌恶",
    "melancholic": "低落",
    "surprised": "惊喜",
    "calm": "平静"
  },
  "RHYTHM_PRESETS": {
    "自然叙述": "自然表达，按语义停连",
    "沉稳舒缓": "沉稳舒缓，重音清晰，短语间自然停连",
    "紧凑清晰": "紧凑表达，声母清晰，保持自然换气",
    "轻快活泼": "轻快灵动，声母清楚，短句间自然换气",
    "克制停连": "克制表达，短语边界清楚，停连分明",
    "低声内敛": "低声内敛，韵母轻收，短语间自然停连",
    "威严有力": "坚定有力，重音明确，停顿干脆"
  },
  "PACE_PRESETS": {
    "自然": [
      "medium",
      "自然表达，按语义停连"
    ],
    "舒缓": [
      "slow",
      "舒缓表达，韵母自然舒展，短语间停连清晰"
    ],
    "紧凑": [
      "fast",
      "紧凑表达，声母清晰，保持自然换气"
    ],
    "轻快": [
      "medium",
      "轻快表达，短句间自然换气"
    ],
    "克制": [
      "medium",
      "克制表达，重音内收，停连清楚"
    ],
    "低声": [
      "medium",
      "低声表达，韵母轻收，短语间自然停连"
    ],
    "强调": [
      "medium",
      "重点词清晰强调，语义停顿明确"
    ]
  },
  "ATTITUDE_PRESETS": {
    "中性叙述": "中性、客观地叙述",
    "沉稳叙述": "沉稳、从容地叙述",
    "温和交流": "温和、亲切地交流",
    "紧张警觉": "紧张、警觉地表达",
    "克制低沉": "克制、低沉地表达",
    "悲伤压抑": "悲伤、压抑地表达",
    "喜悦明快": "喜悦、明快地表达",
    "愤怒强烈": "愤怒、强烈地表达",
    "恐惧迟疑": "恐惧、迟疑地表达",
    "威严命令": "威严、明确地命令"
  },
  "EMOTION_DIRECTION_PRESETS": {
    "auto": [
      "跟随基础情绪",
      "",
      0.6
    ],
    "sly_smile": [
      "坏笑着说",
      "speaking with a sly mischievous smile, slightly teasing and amused",
      0.8
    ],
    "urgent_question": [
      "急切地问",
      "urgent and impatient, asking quickly and eagerly, fast-paced speech with strong questioning intonation",
      0.85
    ],
    "inner_thought": [
      "暗自思忖",
      "quiet internal monologue, thinking to oneself, contemplative and suspicious, subdued voice with slight hesitation",
      0.7
    ],
    "cold_statement": [
      "冷冷地说",
      "cold and restrained, emotionally distant, speaking slowly with a firm controlled tone",
      0.7
    ],
    "hushed_warning": [
      "压低声音警告",
      "lowered voice, tense and cautionary, delivering a controlled warning with deliberate emphasis",
      0.8
    ],
    "restrained_sadness": [
      "强忍悲伤",
      "holding back grief, subdued and fragile, restrained sorrow with slight breathiness",
      0.75
    ],
    "angry_interrogation": [
      "愤怒质问",
      "angry and confrontational questioning, forceful emphasis, rising intensity and sharp interrogative intonation",
      0.9
    ],
    "fearful_whisper": [
      "惊恐低语",
      "fearful whisper, tense breathing, hesitant and alarmed while keeping the voice low",
      0.8
    ],
    "gentle_comfort": [
      "温柔安慰",
      "gentle and reassuring, warm compassionate tone, calm pacing with soft supportive emphasis",
      0.65
    ],
    "excited_announcement": [
      "兴奋宣布",
      "excited and energetic announcement, bright tone, lively pacing and clear enthusiastic emphasis",
      0.8
    ],
    "custom": [
      "自定义描述",
      "",
      0.7
    ]
  },
  "PACE_FACTORS": {
    "slow": 1.18,
    "medium": 1.05,
    "fast": 0.92
  },
  "SPEAKER_SIMILARITY_THRESHOLD": 0.82
}
